package br.com.texeratx.boardgametimeapp.ui.screens.expansions.create

import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import br.com.texeratx.boardgametimeapp.core.image.ImageSourcePickerDialog
import br.com.texeratx.boardgametimeapp.core.image.rememberImageSourceState
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.currentOrThrow
import org.koin.compose.koinInject

class CreateExpansionScreen(
    private val prefilledGameId: Long? = null
) : Screen {

    @Composable
    override fun Content() {
        val viewModel = koinInject<CreateExpansionViewModel>()
        val state by viewModel.state.collectAsState()

        val snackbarHostState = remember { SnackbarHostState() }
        val navigator = cafe.adriel.voyager.navigator.LocalNavigator.currentOrThrow

        val imageSource = rememberImageSourceState { picked ->
            if (picked != null) viewModel.onImageSelected(picked)
        }

        ImageSourcePickerDialog(imageSource)

        LaunchedEffect(prefilledGameId) {
            viewModel.load(prefilledGameId)
        }

        LaunchedEffect(state.uiMessage) {
            state.uiMessage?.let {
                snackbarHostState.showSnackbar(it)
                viewModel.consumeMessage()
            }
        }

        CreateExpansionUI(
            state = state,
            snackbarHost = { SnackbarHost(snackbarHostState) },
            onBack = { navigator.pop() },
            onNameChange = viewModel::onNameChange,
            onBggUrlChange = viewModel::onBggUrlChange,
            onGameSelected = viewModel::onGameSelected,
            onPickImage = imageSource.onLaunch,
            onClearImage = viewModel::clearLocalImage,
            onSave = {
                viewModel.createExpansion(
                    onSuccess = { navigator.pop() }
                )
            },
            onDismissError = viewModel::clearError
        )
    }
}
